import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthSiteStore } from '../../user/authSiteStore'
import { useAuthUserStore } from '../../user/authUserStore'

const isNavigatingState = ref(false)

export function useNavigation() {
    const authSiteStore = useAuthSiteStore()
    const { current, currentIsLoading, currentConfigIsLoading } = storeToRefs(authSiteStore)

    const authUserStore = useAuthUserStore()
    const { hasCheckedSession } = storeToRefs(authUserStore)

    
    const loadingMessage = computed(() => {
        if (!hasCheckedSession.value) {
            return 'Logging In...'
        }
    
        if (currentIsLoading.value) {
            return 'Getting Your Site...'
        }
    
        if (currentConfigIsLoading.value) {
            return `Loading ${current.value?.name} Settings...`
        }
    
        return 'Loading...'
    })

    const isNavigating = computed(() => isNavigatingState.value)

    const beginNavigation = () => {
        isNavigatingState.value = true
    }

    const endNavigation = () => {
        isNavigatingState.value = false
    }

    return {
        loadingMessage,
        isNavigating,
        beginNavigation,
        endNavigation,
    }
}